import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { refreshUser } = useAuth();
  const nav = useNavigate();
  const [msg, setMsg] = useState("Signing you in…");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    // Intentionally run once on mount. `nav` and `refreshUser` are stable across renders
    // via react-router / useCallback so pinning deps to [] is safe here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (async () => {
      try {
        const hash = window.location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const session_id = params.get("session_id");
        if (!session_id) { nav("/login"); return; }
        const { data } = await api.post("/auth/google/session", { session_id });
        // Save session_token as bearer fallback for browsers that block cross-domain cookies (iOS Safari ITP)
        if (data?.session_token) localStorage.setItem("charge1_token", data.session_token);
        // Fall back to bearer if cookie blocked
        if (data?.user?.user_id) {
          const u = await refreshUser().catch(() => data.user);
          if (data.needs_onboarding || u?.goal == null || u?.daysPerWeek == null || u?.age == null) nav("/onboarding");
          else nav("/dashboard");
        } else {
          setMsg("Auth failed.");
        }
      } catch (e) {
        setMsg("Auth failed. Try again.");
        setTimeout(() => nav("/login"), 1500);
      }
    })();
  }, [nav, refreshUser]); // done.current guard prevents duplicate runs

  return (
    <div className="min-h-screen bg-app flex items-center justify-center text-t3 text-xs tracking-widest uppercase" data-testid="auth-callback">{msg}</div>
  );
}
